
//------------------------------------------------------------------------------
// <auto-generated>
//     This code was generated from a template (Model.tst).
//
//     Manual changes to this file may cause unexpected behavior in your application.
//     Manual changes to this file will be overwritten if the code is regenerated.
// </auto-generated>
//------------------------------------------------------------------------------

import { ContactModel } from './Entities.GormCrm.Contact';
import { CompanyContactModel } from './Entities.GormCrm.CompanyContact';
import { CompanyExternalKeyModel } from './Entities.GormCrm.CompanyExternalKey';
import { CompanyResponsibleModel } from './Entities.GormCrm.CompanyResponsible';
import { OrderModel } from './Entities.GormCrm.Order';
import { ProductPlanModel } from './Entities.GormCrm.ProductPlan';
import { QuestionnaireQuestionReplyModel } from './Entities.GormCrm.QuestionnaireQuestionReply';
import { SaleAgreementModel } from './Entities.GormCrm.SaleAgreement';
import { SaleAttachmentModel } from './Entities.GormCrm.SaleAttachment';
import { SettlementModel } from './Entities.GormCrm.Settlement';
import { TaskAttachmentModel } from './Entities.GormCrm.TaskAttachment';
import { TaskflowModel } from './Entities.GormCrm.Taskflow';
import { TransferModel } from './Entities.GormCrm.Transfer';
import { Model, ModelProperty } from 'models/Model';


export class CompanyModel extends Model<CompanyModel> {
	public static classProperties: ModelProperty[] = [
		
		{ name: 'id', type: 'string', isHidden: true },
		{ name: 'vatNumber', type: 'string' },
		{ name: 'name', type: 'string' },
		{ name: 'address', type: 'string' },
		{ name: 'zipcode', type: 'string' },
		{ name: 'city', type: 'string' },
		{ name: 'country', type: 'string' },
		{ name: 'billingVatNumber', type: 'string' },
		{ name: 'billingGln', type: 'string' },
		{ name: 'billingName', type: 'string' },
		{ name: 'billingAddress', type: 'string' },
		{ name: 'billingZipcode', type: 'string' },
		{ name: 'billingCity', type: 'string' },
		{ name: 'billingCountry', type: 'string' },
		{ name: 'created', type: 'Date', isHidden: true },
		{ name: 'deleted', type: 'Date', isHidden: true },
		{ name: 'businessCode', type: 'string' },
		{ name: 'businessName', type: 'string' },
		{ name: 'businessType', type: 'string' },
		{ name: 'employees', type: 'string' },
		{ name: 'establishmentDate', type: 'Date' },
		{ name: 'advertisingProtection', type: 'boolean' },
		{ name: 'businessStatus', type: 'string' },
		{ name: 'billingContactId', type: 'string' },
		{ name: 'primaryContactId', type: 'string' },
		{ name: 'billingContact', type: 'ContactModel', isHidden: true, isObject: true, new: () => { return new ContactModel }, properties: () => { return ContactModel.classProperties } },
		{ name: 'companyContacts', type: 'CompanyContactModel[]', isHidden: true, isArray: true, isObject: true, new: () => { return new CompanyContactModel }, properties: () => { return CompanyContactModel.classProperties } },
		{ name: 'companyExternalKeys', type: 'CompanyExternalKeyModel[]', isHidden: true, isArray: true, isObject: true, new: () => { return new CompanyExternalKeyModel }, properties: () => { return CompanyExternalKeyModel.classProperties } },
		{ name: 'companyResponsibles', type: 'CompanyResponsibleModel[]', isHidden: true, isArray: true, isObject: true, new: () => { return new CompanyResponsibleModel }, properties: () => { return CompanyResponsibleModel.classProperties } },
		{ name: 'orders', type: 'OrderModel[]', isHidden: true, isArray: true, isObject: true, new: () => { return new OrderModel }, properties: () => { return OrderModel.classProperties } },
		{ name: 'primaryContact', type: 'ContactModel', isHidden: true, isObject: true, new: () => { return new ContactModel }, properties: () => { return ContactModel.classProperties } },
		{ name: 'productPlans', type: 'ProductPlanModel[]', isHidden: true, isArray: true, isObject: true, new: () => { return new ProductPlanModel }, properties: () => { return ProductPlanModel.classProperties } },
		{ name: 'questionnaireQuestionReplies', type: 'QuestionnaireQuestionReplyModel[]', isHidden: true, isArray: true, isObject: true, new: () => { return new QuestionnaireQuestionReplyModel }, properties: () => { return QuestionnaireQuestionReplyModel.classProperties } },
		{ name: 'saleAgreements', type: 'SaleAgreementModel[]', isHidden: true, isArray: true, isObject: true, new: () => { return new SaleAgreementModel }, properties: () => { return SaleAgreementModel.classProperties } },
		{ name: 'saleAttachments', type: 'SaleAttachmentModel[]', isHidden: true, isArray: true, isObject: true, new: () => { return new SaleAttachmentModel }, properties: () => { return SaleAttachmentModel.classProperties } },
		{ name: 'settlements', type: 'SettlementModel[]', isHidden: true, isArray: true, isObject: true, new: () => { return new SettlementModel }, properties: () => { return SettlementModel.classProperties } },
		{ name: 'taskAttachments', type: 'TaskAttachmentModel[]', isHidden: true, isArray: true, isObject: true, new: () => { return new TaskAttachmentModel }, properties: () => { return TaskAttachmentModel.classProperties } },
		{ name: 'taskflows', type: 'TaskflowModel[]', isHidden: true, isArray: true, isObject: true, new: () => { return new TaskflowModel }, properties: () => { return TaskflowModel.classProperties } },
		{ name: 'transferFromCompanies', type: 'TransferModel[]', isHidden: true, isArray: true, isObject: true, new: () => { return new TransferModel }, properties: () => { return TransferModel.classProperties } },
		{ name: 'transferToCompanies', type: 'TransferModel[]', isHidden: true, isArray: true, isObject: true, new: () => { return new TransferModel }, properties: () => { return TransferModel.classProperties } },
		{ name: 'externalKeys', type: 'CompanyExternalKeyModel[]', isHidden: true, isArray: true, isObject: true, new: () => { return new CompanyExternalKeyModel }, properties: () => { return CompanyExternalKeyModel.classProperties } }
	];
	[key: string]: any;
	
	public id?: string;
	public vatNumber: string;
	public name: string;
	public address: string;
	public zipcode: string;
	public city: string;
	public country: string;
	public billingVatNumber: string;
	public billingGln: string;
	public billingName: string;
	public billingAddress: string;
	public billingZipcode: string;
	public billingCity: string;
	public billingCountry: string;
	public created?: Date;
	public deleted?: Date;
	public businessCode: string;
	public businessName: string;
	public businessType: string;
	public employees: string;
	public establishmentDate?: Date;
	public advertisingProtection?: boolean;
	public businessStatus: string;
	public billingContactId?: string;
	public primaryContactId?: string;
	public billingContact?: ContactModel;
	public companyContacts: CompanyContactModel[];
	public companyExternalKeys: CompanyExternalKeyModel[];
	public companyResponsibles: CompanyResponsibleModel[];
	public orders: OrderModel[];
	public primaryContact?: ContactModel;
	public productPlans: ProductPlanModel[];
	public questionnaireQuestionReplies: QuestionnaireQuestionReplyModel[];
	public saleAgreements: SaleAgreementModel[];
	public saleAttachments: SaleAttachmentModel[];
	public settlements: SettlementModel[];
	public taskAttachments: TaskAttachmentModel[];
	public taskflows: TaskflowModel[];
	public transferFromCompanies: TransferModel[];
	public transferToCompanies: TransferModel[];
	public externalKeys: CompanyExternalKeyModel[];
    
	constructor(){
		super();
		this.id = undefined;
		this.vatNumber = '';
		this.name = '';
		this.address = '';
		this.zipcode = '';
		this.city = '';
		this.country = '';
		this.billingVatNumber = '';
		this.billingGln = '';
		this.billingName = '';
		this.billingAddress = '';
		this.billingZipcode = '';
		this.billingCity = '';
		this.billingCountry = '';
		this.created = undefined;
		this.deleted = undefined;
		this.businessCode = '';
		this.businessName = '';
		this.businessType = '';
		this.employees = '';
		this.establishmentDate = undefined;
		this.advertisingProtection = undefined;
		this.businessStatus = '';
		this.billingContactId = undefined;
		this.primaryContactId = undefined;
		this.billingContact = undefined;
		this.companyContacts = [];
		this.companyExternalKeys = [];
		this.companyResponsibles = [];
		this.orders = [];
		this.primaryContact = undefined;
		this.productPlans = [];
		this.questionnaireQuestionReplies = [];
		this.saleAgreements = [];
		this.saleAttachments = [];
		this.settlements = [];
		this.taskAttachments = [];
		this.taskflows = [];
		this.transferFromCompanies = [];
		this.transferToCompanies = [];
		this.externalKeys = [];
		
	}
	getProperties(){
		return CompanyModel.classProperties;
	}
}

